import { createTheme } from "@mui/material/styles";

let theme = createTheme({
  palette: {
    primary: {
      main: "rgb(var(--primary-color, 25, 118, 210))",
      contrastText: "#fff",
    },
  },

  typography: {
    fontFamily: "Poppins, Roboto, Arial, sans-serif",
  },
});

theme = createTheme(theme, {
  components: {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          boxShadow: "none",
          maxHeight: "calc(100vh - 190px)",

          [theme.breakpoints.down("sm")]: {
            maxHeight: "calc(100vh - 140px)",
          },
        },
      },
    },

    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTableRow-root": {
            height: "auto",
          },
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          verticalAlign: "middle",
          borderBottom: "1px solid #e8eaed",
          boxSizing: "border-box",
        },
        head: {
          backgroundColor: "#ffffff !important",
          color: "rgba(0, 0, 0, 0.54) !important",
          fontSize: "1rem !important",
          fontWeight: 700,
          padding: "12px 10px",
          borderBottom: "1px solid #d0d5dd",
          lineHeight: 1.35,
          whiteSpace: "normal",
          wordBreak: "break-word",

          [theme.breakpoints.down("sm")]: {
            fontSize: "0.8125rem",
            padding: "10px 8px",
          },
        },
        body: {
          padding: "12px 10px",
          fontSize: "1rem",
          fontWeight: 400,
          color: "rgba(0, 0, 0, 0.7)",

          [theme.breakpoints.down("sm")]: {
            fontSize: "0.8125rem",
            padding: "10px 8px",
          },

          "& *": {
            fontWeight: "inherit",
            fontFamily: "inherit",
          },
        },
        paddingCheckbox: {
          width: 52,
          minWidth: 52,
          maxWidth: 52,
          padding: "12px 8px",
          verticalAlign: "middle",

          [theme.breakpoints.down("sm")]: {
            padding: "10px 6px",
          },

          "&.MuiTableCell-head": {
            backgroundColor: "#f4f6f9",
            borderBottom: "1px solid #d0d5dd",
          },
        },
      },
    },

    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover": {
            background: "#fff !important",
          },
        },
      },
    },

    MuiTablePagination: {
      styleOverrides: {
        root: {
          fontSize: "0.9375rem",
          color: "rgba(0, 0, 0, 0.72)",
          borderTop: "1px solid #d0d5dd",

          [theme.breakpoints.down("sm")]: {
            fontSize: "0.875rem",
          },

          "& .MuiTablePagination-toolbar": {
            minHeight: 52,
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(0.5),
          },

          "& .MuiTablePagination-select": {
            fontSize: "0.9375rem",
            color: "rgba(0, 0, 0, 0.72)",
            paddingTop: theme.spacing(0.75),
            paddingBottom: theme.spacing(0.75),

            [theme.breakpoints.down("sm")]: {
              fontSize: "0.875rem",
            },
          },

          "& .MuiInputBase-root": {
            fontSize: "0.9375rem",
            color: "rgba(0, 0, 0, 0.72)",

            [theme.breakpoints.down("sm")]: {
              fontSize: "0.875rem",
            },
          },
        },
        selectLabel: {
          fontSize: "0.9375rem",
          fontWeight: 500,
          color: "rgba(0, 0, 0, 0.72)",

          [theme.breakpoints.down("sm")]: {
            fontSize: "0.875rem",
          },
        },
        displayedRows: {
          fontSize: "0.9375rem",
          fontWeight: 500,
          color: "rgba(0, 0, 0, 0.72)",

          [theme.breakpoints.down("sm")]: {
            fontSize: "0.875rem",
          },
        },
        actions: {
          color: "rgba(0, 0, 0, 0.72)",
          "& .MuiIconButton-root": {
            padding: 7,
            color: "rgba(0, 0, 0, 0.72)",
          },
          "& .MuiSvgIcon-root": {
            fontSize: "1.25rem",
          },
          "& .Mui-disabled": {
            color: "rgba(0, 0, 0, 0.26)",
          },
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 400,
          borderRadius: "4px",
          padding: "4px 10px",
          fontSize: "1.1rem",

          [theme.breakpoints.down("sm")]: {
            fontSize: "1rem",
            padding: "4px 10px",
          },
        },

        containedPrimary: {
          backgroundColor: "#5d78ff",
          color: "white",
          "&:hover": {
            backgroundColor: "#5d78ff",
          },
          "&.Mui-disabled": {
            backgroundColor: "#ccc",
            color: "#666",
          },
        },
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInput-underline:before": {
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          },
          "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          },
        },
      },
    },

    MuiInput: {
      styleOverrides: {
        root: {
          "&:before": {
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          },
          "&:hover:not(.Mui-disabled):before": {
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          },
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        standard: {
          "&.MuiInput-root:before, & .MuiInput-underline:before": {
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          },
          "&:hover:not(.Mui-disabled, .Mui-error) .MuiInput-underline:before": {
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          },
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "1.1rem",
          fontWeight: 500,

          [theme.breakpoints.down("sm")]: {
            fontSize: "1rem",
          },
        },
      },
    },

    MuiStepLabel: {
      styleOverrides: {
        label: {
          fontSize: "1.3rem",
          fontWeight: 500,

          [theme.breakpoints.down("sm")]: {
            fontSize: "1.1rem",
          },
        },
      },
    },

    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontSize: "1rem",
          fontWeight: 600,
          padding: 0,

          [theme.breakpoints.down("sm")]: {
            fontSize: "0.9rem",
          },
        },
      },
    },

    MuiPickersDay: {
      styleOverrides: {
        root: {
          fontSize: "1rem",

          [theme.breakpoints.down("sm")]: {
            fontSize: "0.9rem",
          },
        },
      },
    },
    MuiDayCalendar: {
      styleOverrides: {
        weekDayLabel: {
          fontSize: "1rem",

          [theme.breakpoints.down("sm")]: {
            fontSize: "0.9rem",
          },
        },
      },
    },

    MuiPickersCalendarHeader: {
      styleOverrides: {
        label: {
          fontSize: "1.3rem",

          [theme.breakpoints.down("sm")]: {
            fontSize: "1.1rem",
          },
        },
      },
    },
  },
});

export default theme;
